/**
 * Created by rhillion on 01/07/2017.
 */
import React, {Component} from 'react'
import {Container, Dropdown, Image} from 'semantic-ui-react'
import * as Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import {firebaseDB, firebaseStorage} from './helpers/fire'

function getCoords(placeId, places){
    console.log(placeId, places)
    var place;
    for(var i in places){
        if(places[i].key === placeId) place = places[i];
    }

    function lat(){
        return place.lat
    }

    function lng(){
        return place.lng
    }

    return {
        lat,
        lng,
    }
}

function getDropDownValues(rawItems){
    if(!rawItems) return;
    var res = rawItems.map(item => {
        return {
            key:item.key,
            value:item.value,
            text:item.text
        }
    });
    console.log(res)
    return res;
}

export default class CardEdit extends Component {

    state = {
        card: {
            weather: [],
            days: [],
            categories: [],
            status: 'active'
        },
        categories: [],
        photo: {}
    }

    displayDateFormat = "DD/MM/YYYY";
    displayTimeFormat = "h:mm A";
    displayDateTimeFormat = this.displayDateFormat + ' ' + this.displayTimeFormat;

    dateFormat = "YYYY-MM-DD";
    timeFormat = "hh:mm:ss a";

    card = {};

    invalid = [];

    invalidFields = {
        date: false,
        timestart: false,
        timeend: false
    };

    weather = [
        {key: 'sunny', text: 'Sunny', value: 'sunny'},
        {key: 'cloudy', text: 'Cloudy', value: 'cloudy'},
        {key: 'rainy', text: 'Rainy', value: 'rainy'}
    ]

    days = [
        {key: 'monday', text: 'Monday', value: 'monday'},
        {key: 'tuesday', text: 'Tuesday', value: 'tuesday'},
        {key: 'wednesday', text: 'Wednesday', value: 'wednesday'},
        {key: 'thursday', text: 'Thursday', value: 'thursday'},
        {key: 'friday', text: 'Friday', value: 'friday'},
        {key: 'saturday', text: 'Saturday', value: 'saturday'},
        {key: 'sunday', text: 'Sunday', value: 'sunday'},
    ]

    //not used anymore as categories come from DB
    categories = [
        {key: 'food', text: 'Food', value: 'food'},
        {key: 'drinks', text: 'Drinks', value: 'drinks'},
        {key: 'live-music', text: 'Live Music', value: 'live-music'},
        {key: 'shopping', text: 'Shopping', value: 'shopping'},
        {key: 'street-market', text: 'Street Market', value: 'street-market'},
        {key: 'museum', text: 'Museum', value: 'museum'},
        {key: 'city-tours', text: 'City Tours', value: 'city-tours'},
        {key: 'events', text: 'Events', value: 'events'},
        {key: 'nightlife', text: 'Nightlife', value: 'nightlife'},
    ]

    constructor(props) {
        super(props)

        this.save = this.save.bind(this)
        this.persist = this.persist.bind(this)
        this.updateCard = this.updateCard.bind(this)
        this.textChange = this.textChange.bind(this)
        this.radioChange = this.radioChange.bind(this)
        this.dateChange = this.dateChange.bind(this)
        this.timeChange = this.timeChange.bind(this)
        this.imageChange = this.imageChange.bind(this)
        this.getImage = this.getImage.bind(this)
        this.uploadImage = this.uploadImage.bind(this)
        this.checkboxChange = this.checkboxChange.bind(this)
        this.dropdownChange = this.dropdownChange.bind(this)
    }

    componentWillMount() {

        this.load('categories');
        this.load('places');

        this.new = true;
        if (this.props.match.params.id) {
            this.new = false;
            this.card = firebaseDB.ref('cards').child(this.props.match.params.id);
            this.card.once('value', snapshot => {
                this.setState({card: snapshot.val()});
            });
        }
        else
            this.card = firebaseDB.ref('cards').push();
    }

    load(entity) {
        firebaseDB.ref(entity).on('value', snapshot => {
            var data = snapshot.val();
            if (data) {
                var records = Object.keys(data).map(key => data[key]), stateObj = {};
                stateObj[entity] = records;
                this.setState(stateObj);
            }
        });
    }

    save() {
        if (!this.formIsValid()) {
            alert(`Please correct ${this.invalid.toString()}`)
            return;
        }

        if (this.state.photo.imageBase64)
            this.uploadImage(imageSnap => {
                this.state.card.image = imageSnap.metadata.downloadURLs[0];
                this.setState({card: this.state.card});
                this.persist();
            });
        else
            this.persist();
    }


    persist() {
        this.state.card.id = this.card.key;
        this.state.card.milli = moment(this.state.card.timestart, this.timeFormat).valueOf();
        var coords = getCoords(this.state.card.place, this.state.places);
        this.state.card.lat = coords.lat();
        this.state.card.lng = coords.lng();
        this.card.set(this.state.card).then(record => {
            if (this.new)
                window.location.href = `/cards/edit/${this.card.key}`;
            else
            //window.location.href = `/cards`;
                console.log('record updated')
        });
    }

    formIsValid() {
        this.invalid = [];
        for (var i in this.invalidFields) {
            if (this.invalidFields[i]) this.invalid.push(i)
        }
        return this.invalid.length < 1;
    }

    populate(val) {
        val = val || {};
        var res = [];
        if(typeof val === 'string')
            res = val
        else
            Object.keys(val).map(function (key, index) {
                res.push(key);
            });
        return res;
    }

    imageChange(e) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                photo: {
                    file: file,
                    imageBase64: reader.result
                }
            });
        }

        reader.readAsDataURL(file)
    }

    textChange(event) {
        this.updateCard(event.target.name, event.target.value);
    }

    radioChange(event) {
        this.updateCard(event.target.name, event.target.value);
    }

    checkboxChange(event) {
        this.updateCard(event.target.name, event.target.checked);
    }

    dropdownChange(event, dropdown) {
        var items = {}

        if (dropdown.multiple)
            dropdown.value.map((item, i) => {
                items[item] = item;
            })
        else
            items = dropdown.value;

        this.updateCard(dropdown.id, items);
    }

    dateChange(date) {
        if (moment(date, this.displayDateFormat, true).isValid()) {
            this.invalidFields.date = false
            this.updateCard('date', date.format(this.dateFormat));
        }
        else
            this.invalidFields.date = true
    }

    timeChange(fieldName, time) {
        if (moment(time, this.displayTimeFormat, true).isValid()) {
            this.invalidFields[fieldName] = false
            this.updateCard(fieldName, time.format(this.timeFormat));
        }
        else
            this.invalidFields[fieldName] = true
    }


    updateCard(key, val) {
        this.state.card[key] = val;
        this.setState({card: this.state.card});
    }

    uploadImage(_cb) {
        if (!this.card.key || !this.state.photo.imageBase64) return
        // Data URL string
        var fileName = Math.floor(Math.random(1, 9) * 10000000);
        firebaseStorage.ref('photos').child(this.card.key).child(fileName.toString()).putString(this.state.photo.imageBase64, 'data_url').then(imageSnapshot => {
            if (typeof _cb === 'function') _cb(imageSnapshot);
        });
    }

    getImage(image_id) {
        if (!this.card.key) return
        // Data URL string
        firebaseStorage.ref('photos').child(this.card.key + '/' + image_id).getDownloadURL().then(function (image) {
            console.log(image)
        }).catch(function (error) {
            console.log(error)
        });
    }

    render() {
        if (this.state.card.id || this.new)
            return (
                <form className="ui form">

                    <div className="ui form">
                        <div className="grouped fields">
                            <label>Status</label>
                            <div className="field">
                                <div className="ui radio checkbox">
                                    <input id="active" onClick={this.radioChange} type="radio" name="status"
                                           defaultValue="active"
                                           defaultChecked={this.state.card.status === 'active'}/>
                                    <label htmlFor="active">Active</label>
                                </div>
                            </div>
                            <div className="field">
                                <div className="ui radio checkbox">
                                    <input id="inactive" onClick={this.radioChange} type="radio" name="status"
                                           defaultValue="inactive"
                                           defaultChecked={this.state.card.status === 'inactive'}/>
                                    <label htmlFor="inactive">Inactive</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="field">
                        <label>Title</label>
                        <input type="text" name="title" placeholder="Title" onChange={this.textChange}
                               defaultValue={this.state.card.title}/>
                    </div>

                    {/*<div className="field">
                     <label>Weather</label>
                     <Dropdown id="weather" onChange={this.dropdownChange} placeholder='Weather' fluid multiple
                     selection options={this.weather}
                     defaultValue={this.populate(this.state.card.weather)}/>
                     </div>*/}

                    <div className="ui form">
                        <div className="grouped fields">
                            <label>Weather level</label>
                            <div className="field">
                                <div className="ui radio checkbox">
                                    <input id="level1" onClick={this.radioChange} type="radio" name="weather"
                                           defaultValue="1"
                                           defaultChecked={this.state.card.weather === "1"}/>
                                    <label htmlFor="level1">Level 1 (Sunny)</label>
                                </div>
                            </div>
                            <div className="field">
                                <div className="ui radio checkbox">
                                    <input id="level2" onClick={this.radioChange} type="radio" name="weather"
                                           defaultValue="2"
                                           defaultChecked={this.state.card.weather === "2"}/>
                                    <label htmlFor="level2">Level 2 (Sunny, Cloudy)</label>
                                </div>
                            </div>
                            <div className="field">
                                <div className="ui radio checkbox">
                                    <input id="level3" onClick={this.radioChange} type="radio" name="weather"
                                           defaultValue="3"
                                           defaultChecked={this.state.card.weather === "3"}/>
                                    <label htmlFor="level3">Level 3 (Sunny, Cloudy, Rainy)</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="ui form">
                        <div className="grouped fields">
                            <label>Frequency</label>
                            <div className="field">
                                <div className="ui radio checkbox">
                                    <input id="weekly" onClick={this.radioChange} type="radio" name="frequency"
                                           defaultValue="weekly"
                                           defaultChecked={this.state.card.frequency === 'weekly'}/>
                                    <label htmlFor="weekly">Weekly</label>
                                </div>
                            </div>
                            <div className="field">
                                <div className="ui radio checkbox">
                                    <input id="date" onClick={this.radioChange} type="radio" name="frequency"
                                           defaultValue="date"
                                           defaultChecked={this.state.card.frequency === 'date'}/>
                                    <label htmlFor="date">Date</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        this.state.card.frequency === "date" &&
                        <div className="field">
                            <label>Date</label>
                            <Datetime id="date" onChange={this.dateChange} placeholder='When'
                                      dateFormat={this.displayDateFormat}
                                      timeFormat={false}
                                      defaultValue={
                                          moment(this.state.card.date).isValid() ?
                                              moment(this.state.card.date).format(this.displayDateFormat) :
                                              moment().format(this.displayDateFormat)}
                            />
                        </div>
                    }


                    {
                        this.state.card.frequency !== "date" &&
                        <div className="field">
                            <label>Day</label>
                            <Dropdown id="days" onChange={this.dropdownChange} placeholder='When' fluid multiple
                                      selection
                                      options={this.days}
                                      defaultValue={
                                          this.populate(
                                              this.state.card.days ?
                                                  this.state.card.days :
                                                  []
                                          )
                                      }/>
                        </div>
                    }

                    <div className="ui form">
                        <div className="grouped fields">
                            <label>Start Time</label>
                            <div className="field">
                                <Datetime id="timestart"
                                          onChange={this.timeChange.bind(this, 'timestart')}
                                          dateFormat={false}
                                          timeFormat={this.displayTimeFormat}
                                          defaultValue={
                                              moment(this.state.card.timestart, this.timeFormat, true).isValid() ?
                                                  moment(this.state.card.timestart, this.timeFormat).format(this.displayTimeFormat) : ''}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="ui form">
                        <div className="grouped fields">
                            <label>End Time</label>
                            <div className="field">
                                <div className="ui checkbox">
                                    <input id="allday" onChange={this.checkboxChange} type="checkbox" name="allday"
                                           defaultChecked={this.state.card.allday}/>
                                    <label htmlFor="allday">All day</label>
                                </div>
                            </div>

                            <div className="field">
                                <Datetime inputProps={{disabled: this.state.card.allday}} id="timeend"
                                          onChange={this.timeChange.bind(this, 'timeend')}
                                          dateFormat={false}
                                          timeFormat={this.displayTimeFormat}
                                          defaultValue={
                                              moment(this.state.card.timeend, this.timeFormat, true).isValid() ?
                                                  moment(this.state.card.timeend, this.timeFormat).format(this.displayTimeFormat) : ''}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="field">
                        <label>Categories</label>
                        <Dropdown id="categories" onChange={this.dropdownChange} placeholder='Category' fluid
                                  multiple
                                  selection options={this.state.categories}
                                  defaultValue={this.populate(this.state.card.categories)}/>
                    </div>

                    <div className="field">
                        <label>Photo</label>
                        <input type="file" name="photo" onChange={this.imageChange}/>
                        {
                            this.state.photo.imageBase64 ?
                                <Image style={{marginTop: 10}} width="200" src={this.state.photo.imageBase64}/> :
                                <Image style={{marginTop: 10}} width="200" src={this.state.card.image}/>
                        }
                    </div>

                    <div className="field">
                        <label>Place</label>
                        <Dropdown id="place" onChange={this.dropdownChange} placeholder='Place' fluid search selection
                                  options={getDropDownValues(this.state.places)}
                                  defaultValue={this.populate(this.state.card.place)}/>
                    </div>

                    <div className="field">
                        <label>Description</label>
                        <textarea type="text" name="description" placeholder="Description" onChange={this.textChange}
                                  defaultValue={this.state.card.description}></textarea>
                    </div>

                    <button className="ui button" type="button" onClick={this.save}>Submit</button>
                    <br/>
                    <br/>
                </form>
            )
        else
            return (
                <Container>
                    Loading...
                </Container>
            )
    }
}


// WEBPACK FOOTER //
// ./src/CardEdit.js